<div class="ic-form-group-title">
	<ng-content select="ic-label" />

	@if (!disabled) {
		<ui-icon-button
			data-test="expand-button"
			help="{{ (formVisible ? 'actions.cancel' : 'actions.add') | translate }}"
			icon="{{ formVisible ? 'fa fa-times-circle' : 'fa fa-plus-circle' }}"
			(action)="toggleForm()"
		/>
	}
</div>

<div class="ic-form-group-container" [class.is-open]="formVisible">
	@if (formVisible) {
		<div class="ic-form-group-form"><ng-content select=".form" /></div>
	}

	<ul>
		@for (item of items; track item; let index = $index) {
			<li>
				@if (itemTemplate) {
					<ng-template
						[ngTemplateOutlet]="itemTemplate"
						[ngTemplateOutletContext]="{ $implicit: item, index: index, isDisabled: disabled }"
					/>
				} @else {
					{{ item }}
				}
			</li>
		}
	</ul>
</div>

<ng-content select=".errors" />
